angular
  .module('app')
  .component('bookingEngine', {
    templateUrl: 'app/components/bookingEngine/BookingEngine.html',
    controller: BookingEngine,
    bindings: {
      hotelConfig: '<',
      bookingEngineConfig: '<',
      categoriesList: '<',
      customerCss: '<'
    }
  });

// eslint-disable-next-line
function BookingEngine(Params, Currency, Categories, ConfigHotel, ConfigBookingEngine, $state, $translate) {
  var $this = this;
  $this.Params = Params;
  $this.Currency = Currency;
  $this.Categories = Categories;
  $this.ConfigHotel = ConfigHotel;
  $this.ConfigBookingEngine = ConfigBookingEngine;
  $this.$state = $state;
  $this.$translate = $translate;
}

BookingEngine.prototype = {
  $onInit: function () {
    if (!this.isValidConfiguration()) {
      this.$state.go('serverErrors', {}, {location: false});
      return;
    }
    this.ConfigHotel.setConfig(this.hotelConfig);
    this.setCategories();
    this.setHotelTime();
    this.ConfigBookingEngine.setConfig(this.bookingEngineConfig);
    this.isEnabled = this.ConfigBookingEngine.isBookingEngineEnabled();
    var finalBookingAcceptanceTime = this.ConfigHotel.getFinalBookingAcceptanceTime();
    this.Params.setMinCheckInTime(finalBookingAcceptanceTime);
    var availableLanguages = this.ConfigBookingEngine.getAvailableLanguages();
    this.Params.setAvailableLanguages(availableLanguages);

    this.userHash = this.getUserHash();
    this.hotelId = this.getHotelId();
    this.language = this.getLanguage();

    /* eslint-disable camelcase */
    this.Currency.setCurrency(this.hotelConfig.currency);
    this.Currency.setCurrencyPrefix(this.hotelConfig.currency_prefix);
    this.Currency.setCurrencySuffix(this.hotelConfig.currency_suffix);
    /* eslint-enable camelcase */
  },

  isValidConfiguration: function () {
    var isValidHotelConfig = angular.isDefined(this.hotelConfig) && this.hotelConfig !== null;
    var isValidBookingEngineConfig = angular.isDefined(this.bookingEngineConfig) && this.bookingEngineConfig !== null;
    var isValidUserHash = this.getUserHash() !== null;
    var isValidHotelId = this.getHotelId() !== null;

    return isValidHotelConfig && isValidBookingEngineConfig && isValidUserHash && isValidHotelId;
  },

  setHotelTime: function () {
    var ConfigHotel = this.ConfigHotel;
    moment.now = function () {
      return ConfigHotel.getTime();
    };
  },

  setCategories: function () {
    if (!angular.isArray(this.categoriesList)) {
      this.categoriesList = [];
    }
    this.categoriesList.unshift({id: null, code: this.$translate.instant('offers.panel.categories.DEFAULT_FILTER')});
    this.Categories.setCategories(this.categoriesList);
  },

  getUserHash: function () {
    return this.Params.getUserHash();
  },

  getHotelId: function () {
    return this.Params.getHotelId();
  },

  getLanguage: function () {
    return this.Params.getLanguage();
  }
};
